import { render } from "./DepositDetailDialog.vue?vue&type=template&id=196692b0"
import script from "./DepositDetailDialog.vue?vue&type=script&lang=js"
export * from "./DepositDetailDialog.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/NfzNB5gn/0/softbot/chatbot/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QBtn,QBadge});qInstall(script, 'directives', {ClosePopup});
